import React from 'react';
import { useCallback } from 'react';
import { FormLabel, Input, Flex, Stack, Tooltip, Box } from '@chakra-ui/react';
import _ from 'lodash';
import { updateComponent } from '../../redux/pagesSlice';
import { selectComponent, selectedComponent } from '../../redux/selectedComponentSlice';
import { selectedPage } from '../../redux/selectedPageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { findCompByIdRecursively } from '../../utils/functions';
import { UilQuestionCircle } from '@iconscout/react-unicons';

export const getInputValues = ({ propValue }) => {
	return [{ placeholder: 'Digite aqui...', value: propValue }];
};
export const getInputNumberValues = ({ propValue }) => {
	return [{ placeholder: 'Ex: 40,50% etc', value: propValue }];
};

const EditorInput = ({ propName, tooltip, title, values, componentId, arrayIndex, originalPropname }) => {
	const [options, setOptions] = React.useState({ title, values });
	const selectedComponentValue = useSelector(selectedComponent);
	const selectedPageValue = useSelector(selectedPage);
	const dispatch = useDispatch();
	const debounceFn = useCallback(_.debounce(handlePagesUpdate, 250), [
		selectedPageValue,
		componentId,
		selectedComponentValue,
	]);

	// React.useEffect(()=>{
	//     setOptions({title,values})
	// },[title,values])

	function handlePagesUpdate(value) {
		const newSelectedComponent = JSON.parse(JSON.stringify(selectedComponentValue));
		const { comp } = findCompByIdRecursively(
			[newSelectedComponent.childComp ?? newSelectedComponent?.props],
			componentId,
		);

		if (typeof comp.props[propName] === 'object') {
			comp.props[propName][title] = value;
		} else if (originalPropname) {
			if (typeof comp.props[originalPropname][arrayIndex][propName] === 'object') {
				comp.props[originalPropname][arrayIndex][propName][title] = value;
			} else {
				comp.props[originalPropname][arrayIndex][propName] = value;
			}
		} else {
			comp.props[propName] = value;
		}

		dispatch(
			updateComponent({
				component: comp,
				componentId,
				pageId: selectedPageValue,
			}),
		);

		if (newSelectedComponent?.childComp) {
			const { comp: originalComp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
			originalComp.props = JSON.parse(JSON.stringify(comp.props));
		}

		dispatch(selectComponent(newSelectedComponent));
	}

	function handleChange(e) {
		// setCaretPos(e.target.selectionEnd)
		let value = e.target.value;
		if (value && !isNaN(value)) {
			value = Number(value);
		}
		const newOptions = JSON.parse(JSON.stringify(options));
		newOptions.values[0].value = value;
		setOptions(newOptions);
		debounceFn(value);
	}

	return (
		<Flex className="mz-hef-edit" flex={'1 1 49%'} maxW={'49%'} flexDir="column">
			<label>
				<Box display={'inline-block'}>{options.title}</Box>
				{/* {!!tooltip && 
                    <Tooltip fontSize='xs' label={tooltip}>
                        <Box display={'inline-block'} >
                            <UilQuestionCircle size='16' />
                        </Box>
                    </Tooltip>} */}
			</label>
			<Stack spacing={2}>
				{options.values.map((el, i) => {
					return (
						<input
							onChange={(e) => {
								handleChange(e);
							}}
							key={i}
							value={el?.value || ''}
							placeholder={el.placeholder}
						/>
					);
				})}
			</Stack>
		</Flex>
	);
};

export default EditorInput;
